var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUmbrella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_490_10709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.38462 3.72857V3.35714C8.38462 3.16071 8.21154 3 8 3C7.78846 3 7.61538 3.16071 7.61538 3.35714V3.72857C5.03654 3.9125 3 5.91786 3 8.35714C3 8.55357 3.17308 8.71429 3.38462 8.71429C3.59615 8.71429 3.76923 8.55357 3.76923 8.35714C3.76923 7.9625 4.11346 7.64286 4.53846 7.64286C4.96346 7.64286 5.30769 7.9625 5.30769 8.35714C5.30769 8.55357 5.48077 8.71429 5.69231 8.71429C5.90385 8.71429 6.07692 8.55357 6.07692 8.35714C6.07692 7.9625 6.42115 7.64286 6.84615 7.64286C7.27115 7.64286 7.61538 7.9625 7.61538 8.35714V12.1071C7.61538 12.6 8.04615 13 8.57692 13C9.10769 13 9.53846 12.6 9.53846 12.1071C9.53846 11.9107 9.36538 11.75 9.15385 11.75C8.94231 11.75 8.76923 11.9107 8.76923 12.1071C8.76923 12.2054 8.68269 12.2857 8.57692 12.2857C8.47115 12.2857 8.38462 12.2054 8.38462 12.1071V8.35714C8.38462 7.9625 8.72885 7.64286 9.15385 7.64286C9.57885 7.64286 9.92308 7.9625 9.92308 8.35714C9.92308 8.55357 10.0962 8.71429 10.3077 8.71429C10.5192 8.71429 10.6923 8.55357 10.6923 8.35714C10.6923 7.9625 11.0365 7.64286 11.4615 7.64286C11.8865 7.64286 12.2308 7.9625 12.2308 8.35714C12.2308 8.55357 12.4038 8.71429 12.6154 8.71429C12.8269 8.71429 13 8.55357 13 8.35714C13 5.91786 10.9635 3.9125 8.38462 3.72857Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_490_10709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella);
export default __webpack_public_path__ + "static/media/umbrella.6603c67ad7c118bd6759c75b5c80e224.svg";
export { ForwardRef as ReactComponent };